import { useContext } from 'react';

import { NavigationContext } from '@/context/navigationContext';

export const useNavigationContext = () => {
  return useContext(NavigationContext);
};
